module.exports = __webpack_public_path__ + "static/media/historyB_md.7f3d3804.jpg";